export default __webpack_public_path__ + "static/media/antelope@3x.e594d8df.jpg";